// Copied from @naturalcycles/nodejs-lib
export const SLUG_REGEX = /^[a-z0-9-]*$/
